import { View } from "@react-pdf/renderer";
import React, { FC } from "react";

import { styles } from "../../PdfDocument.styled";
import PdfDocument from "../../PdfDocument";
import AssetDetails from "../AssetDetails";
import Questions from "../Questions";

interface Assets {
  assets: PdfDocument["assets"];
  mainRelevantYear?: string;
}

const Assets: FC<Assets> = ({ assets, mainRelevantYear }) => {
  if (!assets) {
    return null;
  }

  return assets.map(
    (asset, index: number): React.ReactElement => (
      <View key={asset.id || index.toString()} style={styles.section}>
        <AssetDetails details={asset} />
        <Questions questions={asset.questions} mainRelevantYear={mainRelevantYear} />
      </View>
    ),
  );
};

export default Assets;
